import { render, staticRenderFns } from "./ReporteRelojChecador_old.vue?vue&type=template&id=be5457ec&"
import script from "./ReporteRelojChecador_old.vue?vue&type=script&lang=js&"
export * from "./ReporteRelojChecador_old.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports